
import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Job, JobPostage } from '@/domains/global/models'
import JobInfoTable from '@/domains/jobs/components/Read/JobInfoTable.vue'
import ConfirmModal from '@/domains/global/components/ConfirmModal.vue'

@Component({
  components: { JobInfoTable }
})
export default class JobPostageSection extends Vue {
  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  isEditing = false

  isPostageRequired = false

  postage: Partial<JobPostage> = { country: 'AU' }

  get cancelModal() {
    return this.$refs.cancelModal as ConfirmModal<boolean>
  }

  get confirmModal() {
    return this.$refs.confirmModal as ConfirmModal<boolean>
  }

  @Watch('job', { immediate: true })
  private jobChanged(value: Job) {
    this.isPostageRequired = !!value.postage
    if (value.postage) {
      this.postage = { ...value.postage }
    } else {
      this.postage = { country: 'AU' }
    }
  }

  editPostage() {
    this.isEditing = true
  }

  cancelEdit() {
    this.isEditing = false
    this.resetPostage()
  }

  confirmCancelEdit() {
    this.cancelModal.open(true)
  }

  onSavePostageClick() {
    if (!this.isPostageRequired) {
      this.confirmModal.open(true)
    } else {
      this.savePostage()
    }
  }

  async savePostage() {
    try {
      const postage = this.isPostageRequired ? this.postage : undefined
      await axios.put(`/jobs/${this.job.id}/postage`, { isPostageRequired: this.isPostageRequired, address: postage })
      await this.$store.dispatch('success', 'Postage saved successfully')
      this.isEditing = false
      this.$emit('save')
    } catch (error) {
      await this.$store.dispatch('error', 'An unexpected error occurred processing your request')
      Sentry.captureException(error)
    }
  }

  resetPostage() {
    this.isPostageRequired = this.job.postageRequired || false
    if (this.job.postage) {
      this.postage = this.job.postage
    } else {
      this.postage = { country: 'AU' }
    }
  }
}
